import { render, staticRenderFns } from "./ProfileDisplaySetting.vue?vue&type=template&id=0ee826e0&scoped=true"
import script from "./ProfileDisplaySetting.vue?vue&type=script&lang=ts"
export * from "./ProfileDisplaySetting.vue?vue&type=script&lang=ts"
import style0 from "./ProfileDisplaySetting.vue?vue&type=style&index=0&id=0ee826e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee826e0",
  null
  
)

export default component.exports